export enum Language {
  Swedish = 1053,
  English = 1033,
}
